import { render, staticRenderFns } from "./Formatos.vue?vue&type=template&id=11654e80"
import script from "./Formatos.vue?vue&type=script&lang=js"
export * from "./Formatos.vue?vue&type=script&lang=js"
import style0 from "~/assets/style/toolbar-panels.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports